<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">        
      <!----------------------------配送区域列表（search start）----------------------------------->     
      <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
	      <el-form-item style="width:15%">
          	  <el-select v-model="query.provinceid" clearable remote  filterable placeholder="请选择省份" @change="changecity(query.provinceid)">	            
                  <el-option v-for="(item,index) in provincelists" :label="item.showlable" :value="item.id" :key="index">
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
					  <span style="float: left">{{item.name}}</span>
                  </el-option>              
              </el-select>          
          </el-form-item>
		  <el-form-item style="width:15%" v-if="citylists.length > 0">
          	  <el-select v-model="query.cityid" clearable remote  filterable placeholder="请选择城市" @change="changecityinfos(query.cityid)">	            
                  <el-option v-for="(item,index) in citylists" :label="item.showlable" :value="item.id" :key="index">
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
					  <span style="float: left">{{item.name}}</span>
                  </el-option>              
              </el-select>          
          </el-form-item>
		  <el-button type="warning" size="mini" @click="settinglogisticsinfos">设置运费模板</el-button>
      </el-form>
      <!----------------------------配送区域列表 （search end）------------------------------------>
      
      <el-tag type="danger" closable @close="closetag" v-if="tagshow=='true'" style="margin-top:10px">
	  	温馨提示：1、起订金额为下单时的订单金额，即不满足起订金额无法下单；2、包邮金额为满足了起订金额条件后又满足包邮金额可以进行免运费
	  </el-tag>

      <!------------------------ 配送区域列表（lists start） --------------------------------------------------------->
      <div style="margin-top:10px;padding-bottom:30px;float:left">  
		  <div v-for="(item,index) in lists" v-loading="createListLoading" class="citylists">
		  	  <a style="float:left;width:100%" @click="gotocity(cityid > 0 ? item.cityid : item.id)">
				  <div style="float:left;width:100%;line-height:1rem;padding-bottom:.5rem;border-bottom:1px solid #ddd;font-size:.8rem">
				  	  <span style="float:left;margin-top:.5rem">{{item.name}}</span>
			  	  </div>
			  </a>
			  <el-button circle type="warning" size="mini" icon="el-icon-setting" style="float:right;margin-top:-2.1rem" @click="settingcity(cityid > 0 ? item.cityid : item.id)" v-if="query.provinceid==''"></el-button>
			  <el-button circle type="warning" size="mini" icon="el-icon-setting" style="float:right;margin-top:-2.1rem" @click="checkshipping(item.cityid)" v-if="query.provinceid > 0"></el-button>
			  <el-col v-if="query.provinceid > 0" :span="10" style="font-size:.8rem;margin-top:.5rem;color:#909399">起订金额：</el-col>
			  <el-col v-if="query.provinceid > 0" :span="14" style="font-size:.8rem;margin-top:.5rem"><el-input type="text" size="mini" v-model="item.sendprice" @blur="changeprice(item)"></el-input></el-col>
			  <el-col v-if="query.provinceid > 0" :span="10" style="font-size:.8rem;margin-top:.5rem;color:#909399">包邮金额：</el-col>
			  <el-col v-if="query.provinceid > 0" :span="14" style="font-size:.8rem;margin-top:.5rem"><el-input type="text" size="mini" v-model="item.noticeprice" @blur="changenoticeprice(item)"></el-input></el-col>
			  <!-- 运费模板 -->
			  <el-col v-if="query.provinceid > 0">
			  <div style="float:left;width:100%;margin-top:15px;background:rgb(221,221,221,.4);padding:5px 2px;border-radius:5px">
			  	  <span style="float:left;width:100%;margin-bottom:10px">
					<img src="../../assets/shipping.png" style="float:left;width:30.25px;height:25px;margin-right:10px"/>
					<i style="float:left;width:83%;font-size:14px;line-height:14px;margin-top:5.5px;color:#666666;font-style:normal;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">运费模板（不满足包邮金额时启用）</i>
				  </span>
				  <ul class="arealogisticsarea" style="float:left;width:100%;height:80px;overflow-x:hidden;overflow-y:scroll;padding:0;margin:0;scrollbar-width: none;-ms-overflow-style: none;">
				  	<li v-for="(tt,ii) in item.infos" :key="ii" style="float:left;width:100%;list-style-type:none;padding:5px 2px;">
					  <el-button :type="tt.isdefault==0 ? 'info' : 'success'" icon="el-icon-check" size="mini" circle style="float:left;margin-left:3px;width:15px;height:15px;padding:1px"></el-button>
					  <span style="float:left;margin-left:3%;width:88%;font-size:12px;line-height:15px;color:#666666;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{tt.content}}</span>
					</li>
				  </ul>
			  </div>
			  </el-col>
		  </div>
      </div>
      <!-------------------------------配送区域列表（lists end）------------------------------------------>
	  
	  <!--  信息设置 -->
	  <el-dialog title="起送金额 / 包邮金额信息设置" :visible.sync="settingDialog"  width="22%" top="20vh">
		  <el-col :span="8">起订金额：</el-col>
		  <el-col :span="16"><el-input type="text" size="mini" v-model="settingquery.sendprice"></el-input></el-col>
		  <el-col :span="8" style="margin-top:1rem;margin-bottom:2rem">包邮金额：</el-col>
		  <el-col :span="16" style="margin-top:1rem;margin-bottom:2rem"><el-input type="text" size="mini" v-model="settingquery.noticeprice"></el-input></el-col>
		  <div slot="footer" class="dialog-footer" style="margin-top:20px">
		      <el-button size="mini" @click="settingDialog = false">取 消</el-button>
			  <el-button type="primary" size="mini" @click="savesetting">确 定</el-button>
		  </div>
	  </el-dialog>

	  <!-- 设置运费模板信息 -->
	  <el-dialog title="运费模板信息设置" :visible.sync="logisticsDialog"  width="60%" top="15vh" v-loading="settingloading">
	  	  <div class="express-area-warning">警告：1、更新快递模板信息会联动将该地区下面的城市的快递模板信息一起更新，且将原有快递信息进行覆盖；2、不选择省份的情况下默认为覆盖全国的快递信息，请谨慎使用</div>
	  	  <div class="area-setting">
	  	  <el-form :inline="true" class="demo-form-inline" size="small">
			  <el-form-item label="选择省份：" label-width="120" v-if="logisticssettingquery.issingle==0">
          	    <el-select v-model="logisticssettingquery.provinceid" clearable remote  filterable placeholder="请选择省份" @change="areachangecity(logisticssettingquery.provinceid)">	            
                  <el-option v-for="(item,index) in provincelists" :label="item.showlable" :value="item.id" :key="index">
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
					  <span style="float: left">{{item.name}}</span>
                  </el-option>              
                </el-select>          
			  </el-form-item>
			  <el-form-item label="选择城市：" label-width="120" v-if="areacitylists.length > 0 && logisticssettingquery.issingle==0">
				<el-select v-model="logisticssettingquery.cityid" clearable remote  filterable placeholder="请选择城市" @change="areachangecityinfos(logisticssettingquery.cityid)">	            
					<el-option v-for="(item,index) in areacitylists" :label="item.showlable" :value="item.id" :key="index">
						<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						<span style="float: left">{{item.name}}</span>
					</el-option>              
				</el-select>          
			  </el-form-item>
			  <el-form-item v-if="logisticssettingquery.issingle==1" style="width:30%">
				<template><div>省份名称：{{logisticssettingquery.provincename}}</div></template>
			  </el-form-item>
			  <el-form-item v-if="logisticssettingquery.issingle==1" style="width:30%">
				<template><div>城市名称：{{logisticssettingquery.cityname}}</div></template>
			  </el-form-item>
		  </el-form>
		  <div class="addarealogistics">
		  	<img src="../../assets/packet.png" /><i class="name">快递配送模板</i>
		  	<el-button size="mini" type="danger" icon="el-icon-plus" circle style="float:right;" @click="addexpress"></el-button>
		  </div>
		  <div class="addarealogisticslists">
		  	<ul>
			  <li v-for="(item,index) in logisticssettingquery.infos" :key="index">
			  	<div class="sbt"><el-button size="mini" :type="item.isdefault==1 ? 'success' : 'info'" icon="el-icon-check" circle style="padding:5px" @click="setdefaultlogistics(item)"></el-button></div>
				<div class="lgname">{{item.name}}（{{item.number}}）</div>
			  	<div class="sweight">
				  <el-tooltip class="item" effect="dark" content="首重重量" placement="top">
				  <el-input v-model="item.startweight" placeholder="首重重量" size="mini"><template slot="append">kg</template></el-input>
				  </el-tooltip>
				</div>
				<div class="sprice">
				  <el-tooltip class="item" effect="dark" content="首重金额" placement="top">
				  <el-input v-model="item.startprice" placeholder="首重金额" size="mini"><template slot="prepend">￥</template></el-input>
				  </el-tooltip>
				</div>
				<div class="eweight">
				  <el-tooltip class="item" effect="dark" content="续重重量" placement="top">
				  <el-input v-model="item.againweight" placeholder="续重重量" size="mini"><template slot="append">kg</template></el-input>
				  </el-tooltip>
				</div>
				<div class="eprice">
				  <el-tooltip class="item" effect="dark" content="续重金额" placement="top">
				  <el-input v-model="item.againprice" placeholder="续重金额" size="mini"><template slot="prepend">￥</template></el-input>
				  </el-tooltip>
				</div>
				<div class="sbt"><el-button size="mini" type="danger" icon="el-icon-delete" circle style="padding:5px" @click="dellogistics(index)"></el-button></div>
			  </li>    
			</ul>
		  </div>
		  </div>
		  <div slot="footer" class="dialog-footer" style="margin-top:20px">
		      <el-button size="mini" @click="logisticsDialog = false">取 消</el-button>
			  <el-button type="primary" size="mini" @click="savelogistics">确 定</el-button>
		  </div>
	  </el-dialog>

	  <!-- 选择快递模板信息 -->
	  <el-dialog title="选择快递模板信息" :visible.sync="sendexpressDialog"  width="50%" top="15vh">
		  <el-table :data="sendexpresslists" v-loading="sendexpressloading" style="margin-top:10px;">     
              <el-table-column label="快递名称">
                  <template slot-scope="scope">
                    <div>{{scope.row.name}}（{{scope.row.number}}）</div>
                  </template>
              </el-table-column>
			  <el-table-column label="首重重量 - 首重金额，续重重量 - 续重金额" width="300" align="center">
                  <template slot-scope="scope">
                    <div>{{scope.row.startweight}}kg - {{scope.row.startprice}}，{{scope.row.againweight}}kg - {{scope.row.againprice}}</div>
                  </template>
              </el-table-column>
			  <el-table-column label="操作" align="center" width="90">
                  <template slot-scope="scope">
                    <el-button size="mini" type="success" icon="el-icon-check" circle @click="addexpressmodel(scope.row)"></el-button>
                  </template>
              </el-table-column>
		  </el-table>
      </el-dialog>  

  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Shippingarea/index",
      transitionshow:true,
      lists:[],
      createListLoading:false,
      total_rows:0,
      query: {
      	  act:'getagentcitylists',
          token:this.$cookies.get('token'),
		  provinceid:'',
		  cityid:'',
          key:'',
          rollpage: 10, // 页大小
          p: 1
      },
      tagshow:'true',
      csstop:{'margin-top':'10px'},

	  provincequery: {
		  act:'getcitylists',
		  token:this.$cookies.get('token')
	  },
	  provincelists:[],
	  cityquery: {
		  act:'getcitylists',
		  token:this.$cookies.get('token'),
		  pid:'',
	  },
	  citylists:[],
	  areaprovincequery: {
		  act:'getcitylists',
		  token:this.$cookies.get('token')
	  },
	  areaprovincelists:[],
	  areacityquery: {
		  act:'getcitylists',
		  token:this.$cookies.get('token'),
		  pid:'',
	  },
	  areacitylists:[],
	  settingDialog:false,
	  settingquery: {
		  act:'settingmoney',
		  token:this.$cookies.get('token'),
		  pid:'',
		  sendprice:'',
		  noticeprice:'',
	  },
	  logisticsDialog:false,
	  logisticssettingquery: {
		  act:'savelogisticssetting',
		  token:this.$cookies.get('token'),
		  issingle:0,
		  provinceid:'',
		  provincename:'',
		  cityid:'',
		  cityname:'',
		  infos:[]
	  },

	  sendexpressDialog:false,
	  sendexpressloading:false,
	  sendexpresslists:[],
	  sendexpressquery: {
		  act:'getsendexpresslists',
		  token:this.$cookies.get('token'),
		  expressids:[],
	  },
	  settingloading:false,

    }  
  },
  mounted(){
      this.getList(); //列表
	  this.getprovince(); //获取省份地址信息
  },
  methods:{

	  /** 跳转省份下面的城市 **/
	  gotocity(id) {
		  return false;
		  if(this.query.provinceid=='') {this.query.provinceid=id;this.query.cityid='';}
		  if(this.query.provinceid > 0 && this.query.cityid=='') {this.query.cityid=id;}
		  if(this.query.cityid > 0) this.query.cityid=id;
		  this.getList();
	  },
	  
	  /** 省份信息设置 **/
	  settingcity(id) {
		  this.settingDialog=true;
		  this.settingquery.pid=id;
		  this.settingquery.sendprice='';
		  this.settingquery.noticeprice='';
	  },

	  /** 保存省份信息设置 **/
	  savesetting() {
		  if(this.settingquery.sendprice=='') {this.$message.error('请填写包邮金额');return false;}
		  //if(this.settingquery.noticeprice=='') {this.$message.error('请填写提示金额');return false;}
		  
		  this.$confirm('设置该信息会将该省份底下所包含的二级市的包邮金额、提示金额信息进行覆盖 ？', { type: 'warning' }).then(() => {
        	  var resource = this.$resource(this.url);
		  	  resource.query(this.settingquery).then((res) => {
				  if(res.data.Result>0){
					  if(res.data.Result=='70001') this.$router.push('/login')
					  this.$message.error(res.data.Message);
				  }else {
					  this.settingDialog=false;
					  this.getList();
				  }
			  }).catch((res) => {
				  this.$message.error(this.GLOBAL.errortext);
			  });  	

          }).catch(() => {
            
          });  
	  },


	  /** 获取省份信息列表 **/
	  getprovince() {
		  var resource = this.$resource(this.url);
      	  resource.query(this.provincequery).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
              	  this.$message.error(res.data.Message);
          	  }else {
          	  	  this.provincelists=JSON.parse(Base64.decode(res.data.Data));
				  var _this=this;
				  this.provincelists.forEach(function(e,i) {
					  _this.provincelists[i].id=Number(e.id);
				  });	  
          	  }
      	  }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
      	  });  	  
	  },
	  
	  /** 切换省份 **/
	  changecity(pid) {
		  if(pid=='') {
			  this.query.cityid='';
			  this.citylists=[];
			  this.getList();
		  }else {
			  this.query.cityid='';
			  this.cityquery.pid=pid;
			  this.getcitys(pid);
			  this.getList();
		  }
	  },

	  /** 切换市区 **/
	  changecityinfos(id) {
		  this.query.cityid=id;
		  this.getList();
	  },

	  /** 快递切换省份 **/
	  areachangecity(pid) {
		  if(pid=='') {
			  this.logisticssettingquery.cityid='';
			  this.areacitylists=[];
		  }else {
			  this.logisticssettingquery.cityid='';
			  this.areacityquery.pid=pid;
			  this.getareacitys(pid);
		  }
	  },

	  /** 切换市区 **/
	  areachangecityinfos(id) {
		  this.logisticssettingquery.cityid=id;
	  },


	  /** 获取快递二级市信息 **/
	  getareacitys(pid) {
		  var resource = this.$resource(this.url);
      	  resource.query(this.areacityquery).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
              	  this.$message.error(res.data.Message);
          	  }else {
          	  	  this.areacitylists=JSON.parse(Base64.decode(res.data.Data));
				  var _this=this;
				  this.areacitylists.forEach(function(e,i) {
					  _this.areacitylists[i].id=Number(e.id);
				  });	  
          	  }
      	  }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
      	  });  	  
	  },


	  /** 获取二级市信息 **/
	  getcitys(pid) {
		  var resource = this.$resource(this.url);
      	  resource.query(this.cityquery).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
              	  this.$message.error(res.data.Message);
          	  }else {
          	  	  this.citylists=JSON.parse(Base64.decode(res.data.Data));
				  var _this=this;
				  this.citylists.forEach(function(e,i) {
					  _this.citylists[i].id=Number(e.id);
				  });	  
          	  }
      	  }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
      	  });  	  
	  },

  
  	  /** 获取配送区域信息 **/
  	  getList() {
  	  	  this.createListLoading=true;
  	  	  var resource = this.$resource(this.url);
      	  resource.query(this.query).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
              	  this.$message.error(res.data.Message);
              	  this.createListLoading=false;
          	  }else {
          	  	  this.lists=JSON.parse(Base64.decode(res.data.Data));
                  this.createListLoading=false;
          	  }
      	  }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
          	  this.createListLoading=false;
      	  });  	  
  	  },
  	  
  	  /** 编辑包邮金额 **/
  	  changeprice(item) {
  	  	  var resource = this.$resource(this.url);
      	  resource.save({act:'changeprice',id:item.id,price:item.sendprice,token:this.$cookies.get('token')}).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
              	  this.$message.error(res.data.Message);
          	  }else {

          	  }
      	  }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
      	  });  	  
  	  },

	  /** 编辑起送金额 **/
  	  changenoticeprice(item) {
  	  	  var resource = this.$resource(this.url);
      	  resource.save({act:'changenoticeprice',id:item.id,price:item.noticeprice,token:this.$cookies.get('token')}).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
              	  this.$message.error(res.data.Message);
          	  }else {

          	  }
      	  }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
      	  });  	  
  	  },

  	  
  	  pageProductSizeChange(val) {
          this.query.rollpage = val;
          this.getList();
      },
      pageProductCurrentChange(val) {
          this.query.p = val;
          this.getList();
      },
      
      closetag() {
      	  this.tagshow='false';
      },
	  

	  /** 设置城市快递信息 **/
	  settinglogistics(cityid) {
		  alert(cityid);
	  },

	  
	  /** 快递运费设置 **/
	  settinglogisticsinfos() {
		  this.logisticssettingquery.issingle=0;
		  this.logisticssettingquery.provinceid='';
		  this.logisticssettingquery.cityid='';
		  this.logisticssettingquery.infos=[];
		  this.logisticsDialog=true;
	  },

	  /** 获取可设置的快递信息 **/
	  addexpress() {
		  let _this=this;
		  this.sendexpressDialog=true;
		  this.sendexpressloading=true;
		  var resource = this.$resource(this.url);
		  this.sendexpressquery.expressids=[];
		  this.sendexpresslists=[];
		  this.logisticssettingquery.infos.forEach(function(item,i) {
			  _this.sendexpressquery.expressids.push(item.id);
		  });

      	  resource.query(this.sendexpressquery).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
              	  this.$message.error(res.data.Message);
				  this.sendexpressloading=false;
          	  }else {
				  this.sendexpressloading=false;
				  this.sendexpresslists=JSON.parse(Base64.decode(res.data.Data));
          	  }
      	  }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
			  this.sendexpressloading=false;
      	  });
	  },

	  /** 添加相应的快递信息模板 **/
	  addexpressmodel(item) {
		  this.logisticssettingquery.infos.push({id:item.id,isdefault:0,name:item.name,number:item.number,startweight:item.startweight,startprice:item.startprice,againweight:item.againweight,againprice:item.againprice});
		  this.sendexpressDialog=false;
	  },

	  /** 删除运费模板里的快递信息 **/
	  dellogistics(index) {
		  this.$delete(this.logisticssettingquery.infos,index);
	  },

	  /** 设置默认发货快递信息 **/
	  setdefaultlogistics(item) {
		  this.logisticssettingquery.infos.forEach(function(t,i) {
			  t.id==item.id ? t.isdefault=1 : t.isdefault=0; 
		  });
	  },

	  /** 保存快递模板信息 **/
	  savelogistics() {
		  this.$confirm('警告：1、更新快递模板信息会联动将该地区下面的城市的快递模板信息一起更新，且将原有快递信息进行覆盖；2、不选择省份的情况下默认为覆盖全国的快递信息，请谨慎使用是否继续?', '提示', { type: 'warning' }).then(() => {
			  this.settingloading=true;
			  var resource = this.$resource(this.url);
			  resource.save(this.logisticssettingquery).then((res) => {
				  if(res.data.Result>0){
					  if(res.data.Result=='70001') this.$router.push('/login')
					  this.$message.error(res.data.Message);
					  this.settingloading=false;
				  }else {
					  this.logisticsDialog=false;
					  this.settingloading=false;
					  this.getList();
				  }
			  }).catch((res) => {
				  this.$message.error(this.GLOBAL.errortext);
				  this.settingloading=false;
			  });
					
		  }).catch(() => {
				 
		  });
	  },

	  /** 获取当前城市的快递配送信息 **/
	  checkshipping(cityid) {
		  var resource = this.$resource(this.url);
      	  resource.save({act:'getcityshippings',cityid:cityid,token:this.$cookies.get('token')}).then((res) => {
          	  if(res.data.Result>0){
              	  if(res.data.Result=='70001') this.$router.push('/login')
              	  this.$message.error(res.data.Message);
          	  }else {
				  var result=JSON.parse(Base64.decode(res.data.Data));
				  this.logisticssettingquery.issingle=1;
				  this.logisticssettingquery.provinceid=result.provinceid;
				  this.logisticssettingquery.provincename=result.provincename;
				  this.logisticssettingquery.cityid=result.cityid;
				  this.logisticssettingquery.cityname=result.cityname;
				  this.logisticssettingquery.infos=result.infos;
				  this.logisticsDialog=true;
          	  }
      	  }).catch((res) => {
          	  this.$message.error(this.GLOBAL.errortext);
      	  });
	  },

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.citylists {float:left;width:21.5%;padding:1.5rem 1%;margin:.5rem 1% .5rem 0;background:#fff;border:1px solid #ddd;border-radius:15px;}
.citylists:hover {transition:all .3s;box-shadow: 8px 8px 5px rgb(211,211,211);}
.arealogisticsarea::-webkit-scrollbar {display: none;}
.area-setting .el-form-item__content {width:70%}
.addarealogistics {float:left;width:100%;margin-top:10px;padding:5px;border-bottom:1px solid #dddddd}
.addarealogistics img {float:left;width:25px;height:25px;}
.addarealogistics .name {float:left;font-size:14px;font-style:normal;line-height:14px;margin-left:10px;margin-top:5.5px}
.addarealogisticslists {float:left;width:100%;min-height:50px;}
.addarealogisticslists ul {float:left;width:100%;padding:0;margin-top:15px}
.addarealogisticslists li {float:left;width:100%;padding:5px 10px;list-style-type:none;}
.addarealogisticslists li .sbt {float:left;width:5%}
.addarealogisticslists li .lgname {float:left;font-size:12px;width:12%;margin-right:2%;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.addarealogisticslists li .sweight,.addarealogisticslists li .sprice,.addarealogisticslists li .eweight,
.addarealogisticslists li .eprice {float:left;width:16%;margin-right:2%}
.express-area-warning {padding:5px;border-radius:5px;background-color:rgb(192,196,204,.4);border:1px solid rgb(192,196,204,.1);color:#f56c6c;font-size:12px;line-height:20px;margin-bottom:10px}
</style>


// WEBPACK FOOTER //
// src/components/mall/Shippingarea.vue